import { useEffect } from 'react';

import { Label } from '@eneco/dc/client/types';
import { Customers_Address_AddressModel, DC_Repositories_Base_Enumerations_BusinessUnit } from '@monorepo-types/dc';

import { FlowConsumerContextEnergy } from '../../context';

interface Params {
  addressFinderData: Customers_Address_AddressModel | undefined;
  isHouseNumberSuffixRequired: boolean;
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: Label;
  send: (
    event:
      | {
          type: 'FETCH_ENERGY_TYPES';
          values: FlowConsumerContextEnergy;
        }
      | {
          type: 'done.invoke.getEnergyTypes';
        }
      | {
          type: 'RESET_ENERGY_TYPES';
        },
  ) => void;
}

export function useTriggerFetchEnergyTypes({
  addressFinderData,
  isHouseNumberSuffixRequired,
  businessUnit,
  label,
  send,
}: Params) {
  useEffect(() => {
    const houseNumberSuffix =
      addressFinderData?.houseNumberSuffix !== '-' ? addressFinderData?.houseNumberSuffix?.toString() : '';

    const isAddressComplete =
      !!addressFinderData?.postalCode &&
      !!addressFinderData?.houseNumber &&
      (isHouseNumberSuffixRequired ? !!houseNumberSuffix : true);

    if (isAddressComplete) {
      send({
        type: 'FETCH_ENERGY_TYPES',
        values: {
          postalCode: addressFinderData?.postalCode?.toString(),
          houseNumber: Number(addressFinderData?.houseNumber),
          houseNumberSuffix,
        },
      });
    }
  }, [businessUnit, label, addressFinderData, isHouseNumberSuffixRequired, send]);
}
